import React from "react";

export interface TitleCaseProps {
  text: string;
  maxLength?: number;
}

export default function TitleCase(props: TitleCaseProps): JSX.Element {
  let truncatedString = props.text || "";
  const maxLength = props.maxLength || 20;

  truncatedString = truncatedString.trim();

  if (truncatedString.length > maxLength) {
    truncatedString = truncatedString.substring(0, maxLength) + "...";
  }

  return <>{truncatedString}</>;
}
